import './Question.scss';

function Question({ content }) {
  return <h2 className="question">{content}</h2>;
}

export default Question;
